export default __webpack_public_path__ + "static/media/11-48.82fdf93c.png";